const ProfessionalTierExportHeader = [
  "sfat_quality_pixel_avg",
  "vfat_quality_pixel_avg",
  "muscle_quality_pixel_avg",
  "IMA_quality_pixel_avg",
  "LAMA_quality_pixel_avg",
  "NAMA_quality_pixel_avg",
  "SMA_quality_pixel_avg",
  "sfat_quality_pixel_std",
  "vfat_quality_pixel_std",
  "muscle_quality_pixel_std",
  "IMA_quality_pixel_std",
  "LAMA_quality_pixel_std",
  "NAMA_quality_pixel_std",
  "SMA_quality_pixel_std",
  "sfat_quality_pixel_count",
  "vfat_quality_pixel_count",
  "muscle_quality_pixel_count",
  "IMA_quality_pixel_count",
  "LAMA_quality_pixel_count",
  "NAMA_quality_pixel_count",
  "SMA_quality_pixel_count",
  "pixel_spacing_x",
  "pixel_spacing_y",
  "SFAT_Area",
  "VFAT_Area",
  "Muscle_Area",
  "IMA_Area",
  "LAMA_Area",
  "NAMA_Area",
  "SMA_Area",
];
const FreeTierExportHeader = [
  "SFAT_Area", 
  "VFAT_Area", 
  "Muscle_Area", 
  "IMA_Area", 
  "LAMA_Area", 
  "NAMA_Area", 
  "SMA_Area", 
  "sfat_quality_pixel_avg",
  "vfat_quality_pixel_avg",
  "muscle_quality_pixel_avg",
  "IMA_quality_pixel_avg",
  "LAMA_quality_pixel_avg",
  "NAMA_quality_pixel_avg",
  "SMA_quality_pixel_avg",
  "sfat_quality_pixel_std",
  "vfat_quality_pixel_std",
  "muscle_quality_pixel_std",
  "IMA_quality_pixel_std",
  "LAMA_quality_pixel_std",
  "NAMA_quality_pixel_std",
  "SMA_quality_pixel_std",];

const Constants = {
  ProfessionalTierExportHeader,
  FreeTierExportHeader,
};

export default Constants;
